import * as React from "react";
const SvgFiRrCandy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-candy_svg__a)">
      <path
        fill="#062147"
        d="M5.005 23.992c-2.02-.1-3.872-2.077-4.74-3.761A3.05 3.05 0 0 1 3.413 16C.841 9.025 9.03.845 16 3.413A3.05 3.05 0 0 1 20.231.265a7.97 7.97 0 0 1 3.488 3.5A3.047 3.047 0 0 1 20.587 8C23.158 14.973 14.971 23.158 8 20.587a3.076 3.076 0 0 1-2.995 3.405m-2-6c-2.543.508.405 3.415 1.606 3.909a.986.986 0 0 0 1.39-.922c.082-.988-.3-2.48.52-2.86a1 1 0 0 1 1.018.036C13.425 21.9 21.9 13.42 18.155 7.54A1.007 1.007 0 0 1 19 6h1.983a.984.984 0 0 0 .926-1.392C21.415 3.41 18.5.462 18 3.005c-.082 1 .3 2.5-.52 2.875a.99.99 0 0 1-1.018-.035C13.88 4.2 10.114 4.89 7.5 7.5s-3.3 6.38-1.655 8.958A1.007 1.007 0 0 1 5 18zm11.638-2.51a1 1 0 0 0-1.288-1.528c-1.244 1.047-2.887 1.353-3.75.7a1.002 1.002 0 1 0-1.205 1.6c1.9 1.354 4.4.755 6.243-.767z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-candy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCandy;
